import { defineStyle, defineStyleConfig } from '@chakra-ui/styled-system'

const baseStyle = defineStyle({
  fontSize: '12px',
  margin: '0px',
  fontWeight: '500',
  color: 'presets.neutral.80',
})

export const formLabelTheme = defineStyleConfig({
  baseStyle,
})
